module.exports = __webpack_public_path__ + "VIPV29.png?c856f9c0f6301cfc18a601107e40eb9f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV29.png
// module id = 124
// module chunks = 0